<div class="w-full" [formGroup]="formGroup">
    @if (slot.label) {
        <label
            class="block text-[14px] font-medium text-foreground opacity-80 mb-2"
        >
            {{ slot.label }}
        </label>
    }

    <z-combobox
        [formControlName]="slot.field"
        [options]="options"
        [placeholder]="slot.placeholder || ''"
        [zWidth]="'full'"
        [searchPlaceholder]="'common.search' | transloco"
        (zSearchChange)="onSearchChange($event)"
    ></z-combobox>
</div>
